import { Pipe, PipeTransform } from '@angular/core';
import { IMeter } from '../models/meter.interface';
import { PortfolioDetail } from '../../../data-access/models/portfolio-detail.model';

@Pipe({
  name: 'meters',
  standalone: true,
})
export class MetersPipe implements PipeTransform {
  transform(balance: number, asset: PortfolioDetail[]): IMeter[] {
    return [
      {
        color: '#5B57BD',
        title: 'صندوق‌های درامد ثابت',
        percent:
          100 -
          this.goldAssetsPercents(asset, balance) -
          this.crowdAssetsPercents(asset, balance) -
          this.indexAssetsPercents(asset, balance) -
          this.stockAssetsPercents(asset, balance),
      },
      {
        color: '#FEC003',
        title: 'طلا',
        percent: this.goldAssetsPercents(asset, balance),
      },
      {
        color: '#000060',
        title: 'تامین مالی جمعی',
        percent: this.crowdAssetsPercents(asset, balance),
      },
      {
        color: '#00C958',
        title: 'سهام',
        percent: this.stockAssetsPercents(asset, balance),
      },
      {
        color: '#A7A4FF',
        title: 'شاخصی',
        percent: this.indexAssetsPercents(asset, balance),
      },
    ];
  }

  private goldAssetsPercents(asset: PortfolioDetail[], balance: number): number {
    const golds = asset?.filter((x) => x.type === 'Gold');
    const goldsPrice = golds.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.price;
    }, 0);
    return (goldsPrice / balance) * 100;
  }

  private crowdAssetsPercents(asset: PortfolioDetail[], balance: number): number {
    const crowd = asset?.filter((x) => x.investmentType === 'CrowdFund');
    const crowdsPrice = crowd.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.price;
    }, 0);
    return (crowdsPrice / balance) * 100;
  }

  private stockAssetsPercents(asset: PortfolioDetail[], balance: number): number {
    const stock = asset?.filter((x) => x.investmentType === 'ETF' && x.type === 'Stock');
    const stocksPrice = stock.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.price;
    }, 0);
    return (stocksPrice / balance) * 100;
  }

  private indexAssetsPercents(asset: PortfolioDetail[], balance: number): number {
    const index = asset?.filter((x) => x.investmentType === 'ETF' && x.type === 'Index');
    const indexPrice = index.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.price;
    }, 0);
    return (indexPrice / balance) * 100;
  }
}
